import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as reduxFormReducer } from 'redux-form';

import account from './services/account';
import adblocker from './services/adblocker';
import association from './services/association';
import authentication from './services/authentication';
import banner from './services/banner';
import category from './services/category';
import checkout from './services/checkout';
import contactrequest from './services/contactrequest';
import coupon from './services/coupon';
import criteria from './services/criteria';
import discount from './services/discount';
import directory from './services/directory';
import ebon from './services/ebon';
import emailverification from './services/email-verification';
import enterprisecard from './services/enterprisecard';
import google from './services/google';
import googlepay from './services/googlepay';
import faq from './services/faq';
import filter from './services/filter';
import flashingTicket from './services/flashing-ticket';
import header from './services/header';
import i18n from './services/i18n';
import interstitiel from './services/interstitiel';
import kyc from './services/kyc';
import mea from './services/mea';
import modal from './services/modal';
import nav from './services/nav';
import partner from './services/partner';
import paypal from './services/paypal';
import search from './services/search';
import shop from './services/shop';
import toolbar from './services/toolbar';
import sponsorship from './services/sponsorship';
import unsubscribe from './services/unsubscribe';

const rootReducer = combineReducers({
    [account.constants.NAME]: account.reducer,
    [adblocker.constants.NAME]: adblocker.reducer,
    [association.constants.NAME]: association.reducer,
    [authentication.constants.NAME]: authentication.reducer,
    [banner.constants.NAME]: banner.reducer,
    [category.constants.NAME]: category.reducer,
    [checkout.constants.NAME]: checkout.reducer,
    [contactrequest.constants.NAME]: contactrequest.reducer,
    [coupon.constants.NAME]: coupon.reducer,
    [criteria.constants.NAME]: criteria.reducer,
    [discount.constants.NAME]: discount.reducer,
    [directory.constants.NAME]: directory.reducer,
    [ebon.constants.NAME]: ebon.reducer,
    [emailverification.constants.NAME]: emailverification.reducer,
    [enterprisecard.constants.NAME]: enterprisecard.reducer,
    [faq.constants.NAME]: faq.reducer,
    [filter.constants.NAME]: filter.reducer,
    [flashingTicket.constants.NAME]: flashingTicket.reducer,
    form: reduxFormReducer,
    [google.constants.NAME]: google.reducer,
    [googlepay.constants.NAME]: googlepay.reducer,
    [header.constants.NAME]: header.reducer,
    [i18n.constants.NAME]: i18n.reducer,
    [interstitiel.constants.NAME]: interstitiel.reducer,
    [kyc.constants.NAME]: kyc.reducer,
    [mea.constants.NAME]: mea.reducer,
    [modal.constants.NAME]: modal.reducer,
    [nav.constants.NAME]: nav.reducer,
    [partner.constants.NAME]: partner.reducer,
    [paypal.constants.NAME]: paypal.reducer,
    routing: routerReducer,
    [search.constants.NAME]: search.reducer,
    [shop.constants.NAME]: shop.reducer,
    [sponsorship.constants.NAME]: sponsorship.reducer,
    [toolbar.constants.NAME]: toolbar.reducer,
    [unsubscribe.constants.NAME]: unsubscribe.reducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js